import { render } from "./DetailPembayaranPbb.vue?vue&type=template&id=40d6c54b"
import script from "./DetailPembayaranPbb.vue?vue&type=script&lang=js"
export * from "./DetailPembayaranPbb.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__